export function moveArrayElementPosition<T>(
  array: Array<T>,
  from: number,
  to: number,
) {
  array.splice(to, 0, array.splice(from, 1)[0]);
}
